/**
 * stripInterrogatorTags — single-pass regex layer used everywhere assistant
 * message text is rendered to the founder. Three tag families collapsed into
 * one pipeline so a malformed marker can never slip through by hitting only
 * one of two separate strip passes. Order does not matter — none of the tag
 * families overlap.
 *
 * Handled tags:
 *   [RING N SCORE: X/100 · signal: Y · advance_ready: Z]   — all rings
 *   [Q: N/M]                                                — Ring 4 progress
 *   [FLAG_FIGURE: figure="…" reason="…"]                    — Ring 2 arithmetic
 *
 * A [FLAG_FIGURE: …] tag surfaces to the UI via a separate parser
 * (extractFlagMarkers below) BEFORE this strip runs, so the interrogator's
 * flag suggestions can populate the per-message flag button state.
 */
const TAG_RE =
  /\[RING\s*[1234].*?\]|\[Q:\s*\d+\/\d+\]|\[FLAG_FIGURE:.*?\]/gis;

export function stripInterrogatorTags(text) {
  return (text || "").replace(TAG_RE, "").trim();
}

/**
 * extractFlagMarkers — pull [FLAG_FIGURE: figure="…" reason="…"] tags out of
 * an assistant message. Returns an array of {figure, reason}. The interrogator
 * emits these as suggestions — the actual write to the idea only happens when
 * a human clicks the flag button.
 */
const FLAG_MARKER_RE =
  /\[FLAG_FIGURE:\s*figure\s*=\s*"([^"]+)"\s*(?:reason\s*=\s*"([^"]*)")?\s*\]/gi;

export function extractFlagMarkers(text) {
  const out = [];
  if (!text) return out;
  let m;
  const re = new RegExp(FLAG_MARKER_RE);
  while ((m = re.exec(text)) !== null) {
    out.push({ figure: m[1].trim(), reason: (m[2] || "").trim() });
  }
  return out;
}
